<div class="tool-content-container">
  <div class="tool-description">
    Select Year(s),
    <instruction-step-link
      link="admit-type"
      text="Admit Type(s)"
      [tooltipMessage]="tooltipMessage"
    />,
    <instruction-step-link
      link="tier"
      text="Tier(s)"
      appendedText="[Default: 1-5]"
      tooltipMessage="Default gives all possible values."
    />, Financial Aid Status, High School GPA, and
    <instruction-step-link
      link="uwf-gpa"
      text="UWF GPA"
      appendedText="[Default: 0-4]"
      tooltipMessage="Default gives all possible values."
    />, then click submit to generate cohort profile results.
    <!-- <b class="instructions-title">To generate results for cohort profile:</b
    ><br />
    Step 1 <i class="fa-solid fa-arrow-right"></i> Select Year(s)<br />
    Step 2 <i class="fa-solid fa-arrow-right"></i> Select
    <instruction-step-link
      link="admit-type"
      text="Admit Type(s)"
      [tooltipMessage]="tooltipMessage"
    />
    <br />
    Step 3 <i class="fa-solid fa-arrow-right"></i> Select
    <instruction-step-link
      link="tier"
      text="Tier(s)"
      appendedText="[Default: 1-5]"
      tooltipMessage="Default gives all possible values."
    />
    <br />
    Step 4 <i class="fa-solid fa-arrow-right"></i> Select Financial Aid Status
    [Default: All]<br />
    Step 5 <i class="fa-solid fa-arrow-right"></i> Select the range for High
    School GPA [Default: 0-5]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Default gives all possible values."
      matTooltipPosition="right"
    ></i
    ><br />
    Step 6 <i class="fa-solid fa-arrow-right"></i> Select the range for
    <instruction-step-link
      link="uwf-gpa"
      text="UWF GPA"
      appendedText="[Default: 0-4]"
      tooltipMessage="Default gives all possible values."
    />
    <br />
    Step 7 <i class="fa-solid fa-arrow-right"></i> Click on the submit button -->
  </div>

  <div class="content-wrapper">
    <div *ngIf="this.students">
      <div class="chartjs-container" [class.mat-elevation-z8]="true">
        <div class="chart-title-with-btn-icon">
          <p>FTIC High Dropout Risk</p>
          <button
            matTooltip="Save chart as image"
            mat-icon-button
            aria-label="Chart snap icon"
            (click)="
              dataService.exportChartJsAsPNG(
                'dropout-prone-chart',
                'ftic-dropout-prone'
              )
            "
          >
            <mat-icon>photo_camera</mat-icon>
          </button>
        </div>
        <canvas id="dropout-prone-chart">{{ fticDropoutProneChart }}</canvas>
      </div>

      <form [formGroup]="customChartForm" style="text-align: center">
        <mat-form-field class="student-field-dropdown">
          <mat-label>X-axis</mat-label>
          <mat-select
            formControlName="xaxis"
            required
            (selectionChange)="handleCustomChartXaxisUpdate($event)"
          >
            @for (obj of customChartForm.value.filteredXaxisAttrs; track obj) {
              <mat-option [value]="obj.columnProp">{{ obj.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="student-field-dropdown">
          <mat-label>Attribute</mat-label>
          <mat-select
            formControlName="attribute"
            (selectionChange)="handleCustomChartAttributeUpdate($event)"
          >
            <mat-option>None</mat-option>
            @for (obj of customChartForm.value.filteredAttrAttrs; track obj) {
              <mat-option [value]="obj.columnProp">{{ obj.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="student-field-dropdown">
          <mat-label>Group</mat-label>
          <mat-select
            formControlName="group"
            (selectionChange)="handleCustomChartGroupUpdate($event)"
          >
            <mat-option>None</mat-option>
            @for (obj of customChartForm.value.filteredGroupAttrs; track obj) {
              <mat-option [value]="obj.columnProp">{{ obj.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>

      <div [class.mat-elevation-z8]="true">
        <div style="padding-top: 10px">
          <div class="chart-title-with-btn-icon">
            <p>Left Applied Filters:&nbsp;</p>
            <span style="font-weight: normal !important">{{
              getLeftFiltersText()
            }}</span>
            <button
              matTooltip="Save chart as image"
              mat-icon-button
              aria-label="Chart snap icon"
              (click)="dataService.exportAmChartsAsPNG(root, 'custom-chart')"
            >
              <mat-icon>photo_camera</mat-icon>
            </button>
          </div>
          <p class="chartjs-title">
            Bottom Applied Filters:&nbsp;
            <span style="font-weight: normal !important">{{
              getFiltersText()
            }}</span>
          </p>
          <p class="chartjs-title" *ngIf="!tableData.filteredData.length">
            No data available
          </p>
        </div>

        <div
          id="custom-chart"
          [style.display]="tableData.filteredData.length ? 'block' : 'none'"
        ></div>
      </div>
    </div>
    <!----------------- Cohort Table Filter ----------------->
    <div *ngIf="students" class="filters">
      <mat-form-field
        class="student-field-dropdown"
        appearance="fill"
        *ngFor="let filter of filterSelectObj"
      >
        <mat-label>Filter {{ filter.name }}</mat-label>
        <mat-select
          *ngIf="
            !multiSelectColumns.includes(filter.columnProp);
            else elseBlock
          "
          [(value)]="filter.defaultValue"
          (selectionChange)="filterChange(filter)"
        >
          <mat-option *ngFor="let item of filter.options" [value]="item">{{
            item
          }}</mat-option>
        </mat-select>

        <ng-template #elseBlock>
          <mat-select [(value)]="filter.defaultValue" multiple>
            <mat-select-trigger>
              {{ formatMultiSelectValuesDisplay(filter) }}
            </mat-select-trigger>
            <mat-option
              *ngFor="let item of filter.options"
              [value]="item"
              #matOption
              (click)="clickMultiSelect(item, matOption.selected, filter)"
              >{{
                filter.columnProp === 'tier' && item.toString() === '0'
                  ? 'No Tier'
                  : item
              }}</mat-option
            >
          </mat-select>
        </ng-template>
      </mat-form-field>

      <div class="reset-export-buttons-div">
        <a mat-fab extended style="margin-right: 15px" (click)="resetFilters()">
          <mat-icon>restart_alt</mat-icon>
          Reset
        </a>

        <a mat-fab extended color="primary" (click)="exportData()">
          <mat-icon>download</mat-icon>
          Download
        </a>
      </div>
    </div>

    <!-------------------------------- Cohort Table -------------------------------->
    <div class="mat-elevation-z8 table-responsive">
      <table mat-table [dataSource]="tableData">
        <!-- Student ID Column -->
        <ng-container matColumnDef="uwf_id">
          <th mat-header-cell *matHeaderCellDef>Student ID</th>
          <td mat-cell *matCellDef="let element">{{ element.uwf_id }}</td>
        </ng-container>

        <!-- Student Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Student Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <!-- Cohort year Column -->
        <ng-container matColumnDef="cohort">
          <th mat-header-cell *matHeaderCellDef>Cohort</th>
          <td mat-cell *matCellDef="let element">{{ element.cohort }}</td>
        </ng-container>

        <!-- Admit Type Column -->
        <ng-container matColumnDef="admit_type">
          <th mat-header-cell *matHeaderCellDef>Admit Type</th>
          <td mat-cell *matCellDef="let element">{{ element.admit_type }}</td>
        </ng-container>

        <!-- Prior Hours Column -->
        <ng-container matColumnDef="prior_hours">
          <th mat-header-cell *matHeaderCellDef>Prior Hours</th>
          <td mat-cell *matCellDef="let element">{{ element.prior_hours }}</td>
        </ng-container>

        <!-- Enroll Status Column -->
        <ng-container matColumnDef="enroll_status">
          <th mat-header-cell *matHeaderCellDef>Enroll Status</th>
          <td mat-cell *matCellDef="let element">
            {{ element.enroll_status }}
          </td>
        </ng-container>

        <!-- Current Earn Hours Column -->
        <ng-container matColumnDef="current_earn_hrs">
          <th mat-header-cell *matHeaderCellDef>Last Semester Earn Hours</th>
          <td mat-cell *matCellDef="let element">
            {{ element.current_earn_hrs }}
          </td>
        </ng-container>

        <!-- Active Status Column -->
        <ng-container matColumnDef="active_status">
          <th mat-header-cell *matHeaderCellDef>Active Status</th>
          <td mat-cell *matCellDef="let element">
            {{ element.active_status }}
          </td>
        </ng-container>

        <!-- Total University Hours Column -->
        <ng-container matColumnDef="total_univ_hours">
          <th mat-header-cell *matHeaderCellDef>Total University Hours</th>
          <td mat-cell *matCellDef="let element">
            {{ element.total_univ_hours }}
          </td>
        </ng-container>

        <!-- Last Semester Attended Column -->
        <ng-container matColumnDef="last_semester_attended">
          <th mat-header-cell *matHeaderCellDef>Last Semester Attended</th>
          <td mat-cell *matCellDef="let element">
            {{ element.last_semester_attended }}
          </td>
        </ng-container>

        <!-- First pell indicator Column -->
        <ng-container matColumnDef="pell_first_semester_ind">
          <th mat-header-cell *matHeaderCellDef>PELL First Semester</th>
          <td mat-cell *matCellDef="let element">
            {{ element.pell_first_semester_ind }}
          </td>
        </ng-container>

        <!-- Last Semester Hours Taken Column -->
        <ng-container matColumnDef="last_semester_hours_taken">
          <th mat-header-cell *matHeaderCellDef>Last Semester Hours Taken</th>
          <td mat-cell *matCellDef="let element">
            {{ element.last_semester_hours_taken }}
          </td>
        </ng-container>

        <!-- Term Column -->
        <ng-container matColumnDef="term">
          <th mat-header-cell *matHeaderCellDef>Term</th>
          <td mat-cell *matCellDef="let element">{{ element.term }}</td>
        </ng-container>

        <!-- Classification Column -->
        <ng-container matColumnDef="classification">
          <th mat-header-cell *matHeaderCellDef>Classification</th>
          <td mat-cell *matCellDef="let element">
            {{ element.classification }}
          </td>
        </ng-container>

        <!-- College Column -->
        <ng-container matColumnDef="college">
          <th mat-header-cell *matHeaderCellDef>College</th>
          <td mat-cell *matCellDef="let element">{{ element.college }}</td>
        </ng-container>

        <!-- Department Column -->
        <ng-container matColumnDef="department">
          <th mat-header-cell *matHeaderCellDef>Department</th>
          <td mat-cell *matCellDef="let element">{{ element.department }}</td>
        </ng-container>

        <!-- UWF GPA Column -->
        <ng-container matColumnDef="uwf_gpa">
          <th mat-header-cell *matHeaderCellDef>UWF GPA</th>
          <td mat-cell *matCellDef="let element">
            {{ element.uwf_gpa || 'NA' }}
          </td>
        </ng-container>

        <!-- APR Column -->
        <ng-container matColumnDef="apr_status">
          <th mat-header-cell *matHeaderCellDef>APR</th>
          <td mat-cell *matCellDef="let element">
            {{ element.apr_status || 'NA' }}
          </td>
        </ng-container>

        <!-- Year Code Column -->
        <ng-container matColumnDef="year_code">
          <th mat-header-cell *matHeaderCellDef>Year Code</th>
          <td mat-cell *matCellDef="let element">
            {{ element.year_code }}
          </td>
        </ng-container>

        <!-- HS GPA Column -->
        <ng-container matColumnDef="high_school_gpa">
          <th mat-header-cell *matHeaderCellDef>HS GPA</th>
          <td mat-cell *matCellDef="let element">
            {{ element.high_school_gpa || 'NA' }}
          </td>
        </ng-container>

        <!-- Tier Column -->
        <ng-container matColumnDef="tier">
          <th mat-header-cell *matHeaderCellDef>Tier</th>
          <td mat-cell *matCellDef="let element">{{ element.tier || 'NA' }}</td>
        </ng-container>

        <!-- Gender Column -->
        <ng-container matColumnDef="gender">
          <th mat-header-cell *matHeaderCellDef>Gender</th>
          <td mat-cell *matCellDef="let element">
            {{ element.gender || 'NA' }}
          </td>
        </ng-container>

        <!-- Ethnicity Column -->
        <ng-container matColumnDef="ethnicity">
          <th mat-header-cell *matHeaderCellDef>Ethnicity</th>
          <td mat-cell *matCellDef="let element">
            {{ element.ethnicity || 'NA' }}
          </td>
        </ng-container>

        <!-- Graduation Status Column -->
        <ng-container matColumnDef="graduation_status">
          <th mat-header-cell *matHeaderCellDef>Grad Status</th>
          <td
            mat-cell
            *matCellDef="let element"
            [ngStyle]="{
              color:
                element.graduation_status === 'OnTime'
                  ? 'green'
                  : element.graduation_status === 'OverTime'
                    ? 'orange'
                    : element.graduation_status === 'NoDegree'
                      ? 'red'
                      : '',
            }"
          >
            {{ element.graduation_status }}
          </td>
        </ng-container>

        <!-- Senior Grant Amount Column -->
        <ng-container matColumnDef="senior_grant_ind">
          <th mat-header-cell *matHeaderCellDef>Senior Grant</th>
          <td mat-cell *matCellDef="let element">
            {{ element.senior_grant_ind }}
          </td>
        </ng-container>

        <!-- At Risk Column -->
        <ng-container matColumnDef="canvas_at_risk">
          <th mat-header-cell *matHeaderCellDef>At Risk (Canvas)</th>
          <td mat-cell *matCellDef="let element">
            {{ element.canvas_at_risk || 'NA' }}
          </td>
        </ng-container>

        <!-- Dropout Column -->
        <ng-container matColumnDef="dropout_risk">
          <th mat-header-cell *matHeaderCellDef>Dropout Risk</th>
          <td mat-cell *matCellDef="let element">
            {{ element.dropout_risk || 'NA' }}
          </td>
        </ng-container>

        <!-- Max SEP Grad Year Column -->
        <ng-container matColumnDef="sep_max_grad_term">
          <th mat-header-cell *matHeaderCellDef>Max SEP</th>
          <td mat-cell *matCellDef="let element">
            {{ element.sep_max_grad_term || 'NA' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          class="student-term-row"
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="viewStudent(row)"
        ></tr>
      </table>

      <mat-paginator
        [pageSizeOptions]="[10, 20, 30]"
        showFirstLastButtons
        aria-label="cohort profile table"
      >
      </mat-paginator>
    </div>
  </div>

  <back-button></back-button>
</div>
